/* eslint-disable */
require('./accept')
require('./add-black')
require('./add-grey')
require('./add')
require('./ai-summary-icon')
require('./ai-wand')
require('./air_small')
require('./air_type')
require('./air')
require('./arrow-down')
require('./arrow-up')
require('./arrow')
require('./attachment')
require('./auto-completed')
require('./bid-quote')
require('./bids')
require('./billing')
require('./calendar')
require('./cancel')
require('./cancelblack-trans')
require('./cancelblack')
require('./cancelnocolor')
require('./cancelwhite')
require('./categorydropdown')
require('./changetruck')
require('./Chart')
require('./clipboard')
require('./close-icon')
require('./close-light')
require('./close')
require('./ColumnMenu')
require('./Comment-mark')
require('./Comments')
require('./contract')
require('./Cost')
require('./credit-note')
require('./creditnote')
require('./dashboard-applied')
require('./dashboard')
require('./data')
require('./dbcategorydropdown')
require('./debit-note')
require('./debitnote')
require('./delete')
require('./depot')
require('./details')
require('./document-error')
require('./document')
require('./documents')
require('./done')
require('./download-icon')
require('./download')
require('./downloadnocolor')
require('./drop-off-arrow')
require('./dropdown-blue')
require('./dropdown')
require('./edit-trans')
require('./edit')
require('./eml')
require('./empty-dashboard-dark')
require('./empty-dashboard-light')
require('./empty-dashboard')
require('./empty-dropoffs-selected')
require('./empty-dropoffs')
require('./empty-location')
require('./empty-materials')
require('./empty-timeline')
require('./emptylocation')
require('./eway-error')
require('./eway')
require('./excel')
require('./exclamation')
require('./Exception')
require('./expand')
require('./external')
require('./fill_arrow')
require('./fill_arrow_white')
require('./filter')
require('./filter_menu')
require('./filtericon')
require('./first-in-allotment')
require('./freight-blue')
require('./freight-universal-white')
require('./freight-universal')
require('./freight')
require('./green-circle-tick')
require('./icon-accordion-arrow-left')
require('./icon-accordion-arrow-right')
require('./icon-action-abort')
require('./icon-action-details')
require('./icon-action-documents')
require('./icon-action-edit')
require('./icon-action-resolve')
require('./icon-action-truck-in')
require('./icon-action-truck-out')
require('./icon-add-dark')
require('./icon-add')
require('./icon-ai-agent-sparkle')
require('./icon-announcement')
require('./icon-arrow-switch')
require('./icon-arrow-up')
require('./icon-attachment-sm')
require('./icon-bill-discount')
require('./icon-calendar-input')
require('./icon-cancelled')
require('./icon-clone-md')
require('./icon-clone')
require('./icon-close-risk')
require('./icon-close')
require('./icon-comment')
require('./icon-complete')
require('./icon-connector')
require('./icon-consignee')
require('./icon-consolidate')
require('./icon-container-md')
require('./icon-correct')
require('./icon-currency')
require('./icon-currency-2')
require('./icon-currency-dollar')
require('./icon-dark-search')
require('./icon-dashboard-sm')
require('./icon-delete-md')
require('./icon-details')
require('./icon-dispatch')
require('./icon-dock')
require('./icon-document')
require('./icon-down-arrow')
require('./icon-down-left')
require('./icon-download-xl')
require('./icon-download')
require('./icon-drop-up')
require('./icon-edit-md')
require('./icon-edit-white')
require('./icon-edit')
require('./icon-email-transporter')
require('./icon-error-info')
require('./icon-excel')
require('./icon-expand-minus')
require('./icon-expand-plus')
require('./icon-expand-xl')
require('./icon-eye-hide')
require('./icon-eye-view')
require('./icon-features')
require('./icon-fetch-md')
require('./icon-arrow-switch')
require('./icon-fetch')
require('./icon-filter')
require('./icon-gauge')
require('./icon-global-search')
require('./icon-gps')
require('./icon-csp-tracking')
require('./icon-incorrect')
require('./icon-indent-type')
require('./icon-info-circle-xl')
require('./icon-info-circle')
require('./icon-inspection')
require('./icon-integrations')
require('./icon-intransit')
require('./icon-json')
require('./icon-link-broken')
require('./icon-lms')
require('./icon-location-sm')
require('./icon-location')
require('./icon-lock-open')
require('./icon-material-grid-md')
require('./icon-material-source')
require('./icon-material')
require('./icon-menu-exim')
require('./icon-menu-features')
require('./icon-menu-settings')
require('./icon-minus-dark')
require('./icon-mobile')
require('./icon-navigation')
require('./icon-no-exceptions')
// require('./icon-no-indents') // moved to component-level import
require('./icon-notification-active')
require('./icon-notification')
require('./icon-ocean-xl')
require('./icon-ocean')
require('./icon-pack')
require('./icon-pdf')
require('./icon-print-xl')
require('./icon-print')
require('./icon-profile')
require('./icon-re-indent')
require('./icon-reached')
require('./icon-records')
require('./icon-rejections')
require('./icon-release-off')
require('./icon-release-on')
require('./icon-resolve')
require('./icon-return')
require('./icon-risk')
require('./icon-road-xl')
require('./icon-roundtrip')
require('./icon-search')
require('./icon-ship-xl')
require('./icon-sim')
require('./icon-simcard')
require('./icon-sla')
require('./icon-smartphone')
require('./icon-sort')
require('./icon-source')
require('./icon-speaker')
require('./icon-split')
require('./icon-stakeholder')
require('./icon-start-loading')
require('./icon-status-air')
require('./icon-status-contract')
require('./icon-status-domestic')
require('./icon-status-export')
require('./icon-status-hazardous')
require('./icon-status-import')
require('./icon-status-m')
require('./icon-status-market')
require('./icon-status-no-freight')
require('./icon-status-open')
require('./icon-status-optima')
require('./icon-status-primary')
require('./icon-status-ptl')
require('./icon-status-rail')
require('./icon-status-return')
require('./icon-status-road')
require('./icon-status-secondary')
require('./icon-status-ship')
require('./icon-status-vehicle')
require('./icon-status-vendor')
require('./icon-table')
require('./icon-three-dots')
require('./icon-tick-circle')
require('./icon-tick-sm')
require('./icon-tick')
require('./icon-time')
require('./icon-clock')
require('./icon-graph-down')
require('./icon-track')
require('./icon-transit')
require('./icon-truckin')
require('./icon-truckout')
require('./icon-user')
require('./icon-vehicle-md')
require('./icon-vehicle')
require('./icon-vendor-depot')
require('./icon-vertical-card')
require('./icon-view')
require('./icon-warning-circle-xl')
require('./icon-warning-circle')
require('./icon-warning')
require('./icon-zpl')
require('./image_upload')
require('./imggallery')
require('./indent-split-sucess')
require('./indent')
require('./info-black')
require('./info-blue')
require('./info-trans')
require('./info')
require('./keyboard-shortcuts')
require('./keyboard')
require('./left_arrow')
require('./left-arrow')
require('./link')
require('./loading_split')
require('./loading-end')
require('./loading-start')
require('./loading-started')
require('./loading')
require('./loadplan')
require('./location')
require('./lr-notavailable')
require('./lr-trans')
require('./lr')
require('./map-icon')
require('./mark-as-delivered')
require('./marker')
require('./mdm-upload')
require('./mdm')
require('./menu-light')
require('./menu')
require('./menu1')
require('./menu2')
require('./moreicon')
require('./move')
require('./msg')
require('./newnotification')
require('./no_consignee')
require('./no-data-history')
// require('./no-file-uploaded') // moved to component-level import
require('./no-materials')
require('./NoComments')
require('./not-delivered')
require('./not-generated')
require('./notification')
require('./open')
require('./optima')
require('./optimize')
require('./orders')
require('./pando')
require('./pay')
require('./payments')
require('./pdf')
require('./pending-document')
require('./pi_avatar_icon')
require('./pi-avatar-star-active')
require('./pi-avatar-star')
require('./Pi-Avatar')
require('./pick-up-arrow')
require('./Pie')
require('./primary')
require('./primaryarrow')
require('./print')
require('./printnocolor')
require('./ptl')
require('./question')
require('./quote-icon-grey')
require('./quote-icon')
require('./quote-not-accepted')
require('./quote-sent')
require('./quote-trans')
require('./quote')
require('./re-indent-trans')
require('./re-indent')
require('./reached-loadingpoint')
require('./red-circle-x-mark')
require('./refresh')
require('./reject')
require('./reports')
require('./right_arrow')
require('./right-arrow')
require('./rotate-left')
require('./rotate-right')
require('./rupee-error')
require('./rupee')
require('./Save')
require('./search-dark')
require('./search')
require('./sec-searchblack')
require('./secarrow')
require('./secondary')
require('./setting')
require('./shipment-cancel')
require('./SpendChart')
require('./status_contract')
require('./status_market')
require('./status_nofreight')
require('./status_open')
require('./status_optima')
require('./status_return')
require('./status_vendor')
require('./swapclickable')
require('./swapdeactive')
require('./three-dot')
require('./tick-green')
require('./tick')
require('./timeline')
require('./Tpando')
require('./track')
require('./tracking')
require('./transporter_logo')
require('./truckin-trans')
require('./truckin')
require('./truckout-trans')
require('./truckout')
require('./up-arrow-error')
require('./up-arrow-success')
require('./update-trans')
require('./update')
require('./upload')
require('./vehicle-trans')
require('./vehicle')
require('./VolChart')
require('./warning')
require('./WeightChart')
require('./zip-file-format')
require('./Comment')
require('./close-circle')
require('./pando-agents')
